export default "__VITE_ASSET__CKqU5F3d__"